import { fetchFromOldApi } from '~/services/Http';

import { EmploymentDetailProposalSubmitData } from './postData';

export * from './postData';

export const submitEmplDetailsWorkflow = async (
  empId: number,
  emplId: number,
  data: EmploymentDetailProposalSubmitData,
  proposalId?: string,
) => {
  const api = proposalId
    ? `/json/employee/${empId}/employment/${emplId}/detailsproposal/${proposalId}`
    : `/json/employee/${empId}/employment/${emplId}/detailsproposal`;
  return await fetchFromOldApi(api, {
    method: proposalId ? 'PUT' : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then((r) => r.text())
    .catch((e) => {
      const errorResult = e.text();
      return errorResult.then((r: string) => {
        try {
          const rObject = JSON.parse(r);
          if (rObject?.error?.detail?.includes('taxNumber')) {
            return { error: 'laDupTaxNum' };
          }
          return { error: 'laGeneralError' };
        } catch (e) {
          return { error: 'laGeneralError' };
        }
      });
    });
};
